import { requestUnAuth } from './request'

export const getVersion = () => {
  return requestUnAuth({
    url:'version',
    method: 'GET'
  })
}

